/* eslint-disable */
import axios from "axios";

export default {
  methods: {
    // DETALHES
    /**
     * Service que retorna os dados de uma unimed
     * @param {Number} codigoUnimed
     * @return {Promise<{
        "analista": {
          "emailAnalista": String,
          "idUsuarioUnimedGiu": Number,
          "nomeAnalista": String
        },
        "cdUnimed": Number,
        "primeiroDia": Number,
        "segundoDia": Number,
        "textoExibicao": String
      }>}
    */
    getDetalheUnimed(codigoUnimed) {
      return axios.get(this.CriarUrl({
        resource: `adm/unimeds/${codigoUnimed}`
      }));
    },
    /**
       * Service para editar as datas de notificações do detalhe da unimed
       * @param {Number} codigoUnimed
       * @param {Promise<{
        "primeiroDia": Number,
        "segundoDia": Number
      }>} objetoDetalhe
    */
    putDetalheUnimed(codigoUnimed, objetoDetalhe) {
      return axios.put(this.CriarUrl({
        resource: `adm/unimeds/${codigoUnimed}`
      }), objetoDetalhe);
    },

    putClassificacaoUnimed(codigoUnimed, objetoClassificacao) {
      return axios.put(this.CriarUrl({
        resource: `adm/unimeds/classific/${codigoUnimed}`
      }), objetoClassificacao);
    },

    // ANALISTAS
    /**
     * Retorna todos os analistas das unimeds
     * @return {Promise<[
        {
          "cdUnimed": Number,
          "email": String,
          "idUsuarioUnimed": Number,
          "login": String,
          "nome": String
        }
      ]>}
     */
    getAnalistasUnimed() {
      return axios.get(this.CriarUrl({
        resource: `adm/unimeds/analistas`
      }))
    },
    /**
      * Edita o vinculo do analista com a unimed
      * @param {{ "cdUnimed": Number }} params 
      * @param {{
        "cdUnimed": Number,
        "email": String,
        "idUsuarioUnimed": Number,
        "login": String,
        "nome": String
        }} objetoAnalista
    */
    putAnalistaUnimed(params, objetoAnalista) {
      return axios.put(this.CriarUrl({
        resource: `adm/unimeds/analistas`, params
      }), objetoAnalista)
    },

    // CONTATOS
    /**
      * Recupera todos os contatos da unimed
      * @param {{ "cdUnimed": Number }} params
      * @return {Promise<
        [
          {
            "cdUnimed": Number,
            "email": String,
            "id": Number,
            "nome": String,
            "notificacaoAtiva": Boolean,
            "telefone": String
          }
        ]
      >}
    */
    getContatosUnimed(params) {
      return axios.get(this.CriarUrl({
        resource: `adm/unimeds/contatos`, params
      }))
    },
    getContatosExcluidosUnimed(params) {
      return axios.get(this.CriarUrl({
        resource: `adm/unimeds/contatos/excluidos`, params
      }))
    },

    /**
      * Recupera todos os contatos da unimed
      * @param { Number } codigoUnimed
      * @return { Promise<{
          "cdUnimed": Number,
          "email": String,
          "id": Number,
          "nome": String,
          "notificacaoAtiva": Boolean,
          "telefone": String
        }
      >}
    */
    getContatoUnimed(codigoUnimed) {
      return axios.get(this.CriarUrl({
        resource: `adm/unimeds/contatos/${codigoUnimed}`
      }))
    },

    /**
      * Adiciona um contato a listagem de contatos
      * @param {{ "cdUnimed": Number }} params
      * @param {{
        "nome": String,
        "email": String,
        "telefone": String,
        "notificacaoAtiva": Boolean,
        "cdUnimed": Number
      }} objetoContato 
    */
    postContatosUnimed(params, objetoContato) {
      return axios.post(this.CriarUrl({
        resource: `adm/unimeds/contatos`, params
      }), objetoContato);
    },

    /**
      * Adiciona um contato a listagem de contatos
      * @param { Number } idContato
      * @param {{
        "nome": String,
        "email": String,
        "telefone": String,
        "notificacaoAtiva": Boolean
      }} objetoContato 
    */
    putContatosUnimed(idContato, objetoContato) {
      return axios.put(this.CriarUrl({
        resource: `adm/unimeds/contatos/${idContato}`
      }), objetoContato)
    },

    /**
      * Recupera todos os contatos da unimed
      * @param { Number } idContato
    */
    deleteContatosUnimed(idContato) {
      return axios.delete(this.CriarUrl({
        resource: `adm/unimeds/contatos/${idContato}`
      }))
    },

    /**
      * Atualiza o campo notificacaoAtiva
      * @param { Number } idContato 
      * @param {
        {
          "notificacaoAtiva": true
        }
      } objetoNotificacao 
    */
    patchContatosUnimedNotificacao(idContato, objetoNotificacao) {
      return axios.patch(this.CriarUrl({
        resource: `adm/unimeds/contatos/${idContato}`
      }), objetoNotificacao);
    },
  }
};